// ** Initial State
const initialState = {
  data: [],
  total: 1,
  params: {},
  allData: [],
  notifyDelete: null,
  notifyFailedDelete: null,

  selectedUnitData: null
}

const DataTablesReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_DATA':
      return {
        ...state,
        allData: action.allData,        
        data: action.data,
        total: action.totalPages,
        params: action.params
    }
    case 'GET_SELECTED_DETAIL_UNIT':
      return {
        ...state,
        selectedUnitData: action.unitData
      } 
    case 'RESET_SELECTED_DETAIL_UNIT':
      return {
        ...state,
        selectedUnitData: null
      }      
    default:
      return state
  }
}

export default DataTablesReducer
